import React, { useId } from "react";
import {
  ActivityStepType,
  activityStepTypeLabels,
  activityStepTypes,
} from "../activitySteps/activityStepTypes";
import { getConfiguredPillToken } from "../config/palette";
import {
  SingleSelectPillField,
  SingleSelectPillOption,
} from "./SingleSelectPillField";

const activityStepTypeColors: Record<ActivityStepType, string> = {
  text: "blueLight1",
  image: "purpleLight1",
  video: "redLight1",
  timer: "orangeLight1",
  upload: "greenLight1",
  qa: "blueBright",
};

const activityStepTypeOptions: readonly SingleSelectPillOption[] =
  activityStepTypes.map((type) => ({
    id: type,
    value: type,
    label: activityStepTypeLabels[type],
    colorKey: activityStepTypeColors[type],
  }));

export function ActivityStepTypeSelect({
  value,
  onChange,
}: {
  value: ActivityStepType;
  onChange: (value: ActivityStepType) => void;
}) {
  const selectId = useId();

  return (
    <div className="cp-step-type-select">
      <span>Step type</span>
      <SingleSelectPillField
        id={`activity-step-type-${selectId}`}
        value={value}
        options={activityStepTypeOptions}
        onChange={(nextValue) => onChange(nextValue as ActivityStepType)}
        ariaLabel="Step type"
        placeholder="Select a step type"
        searchPlaceholder="Find a step type"
        emptyMessage="No step types found"
        resolveColor={(option) => getConfiguredPillToken(option.colorKey)}
      />
    </div>
  );
}
